<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><em>To my children, Cybèle, Amanda, and Billy Weisser<br/>To my sister, Judith Mary Fleischner</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?762585ad